module.exports = __webpack_public_path__ + "img/tajikistan.3e4b298.webp";